import { StepperActionTypes } from '../../actions/stepper/stepper.actions';
import { IResponseMessage } from 'src/app/shared/models/response-message/IResponseMessage';

export interface StepperState {
    sending: boolean;
    error: IResponseMessage;
    success: string;
    defaultItemIds: { [key: string]: string };
}
const initialState: StepperState = {
    sending: false,
    error: null,
    success: null,
    defaultItemIds: null
};

export function stepperReducer(state: StepperState = initialState, action: any): StepperState {
    switch (action.type) {
        case StepperActionTypes.SEND_STEPPER_FORM: {
            return {
                ...state,
                sending: true,
                success: null
            };
        }
        case StepperActionTypes.SEND_STEPPER_FORM_FAIL: {
            return {
                ...state,
                sending: false,
                success: null,
                error: action.error,

            };
        }
        case StepperActionTypes.SEND_STEPPER_FORM_SUCCESS: {
            return {
                ...state,
                sending: false,
                success: action.message,
                error: null
            };
        }
        case StepperActionTypes.INIT_DEFAULT_ITEM_IDS_SUCCESS: {
            return {
                ...state,
                defaultItemIds: action.defaultItemIds,
            };
        }
        default:
            return state;
    }
}

